import React, { useState, useEffect } from "react";
import Banner from "../../../Components/Common/Banner";
import abou_us_banner_image from '../../../Assets/images/abou_us_banner_image.png';
import about_us_success_image from '../../../Assets/images/about_us_success_image.png';
import WhatWeBelieveComponent from "../../../Components/About/WhatWeBelieve";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import WhatDifferentiates from "../../../Components/About/WhatDifferentiates";
import OurClientele from "../../../Components/About/OurClientele";
import { motion } from 'framer-motion';
import About_Us from '../../../Assets/images/BannerImages/About_Us.png';

// Fallback components (remove these if actual components exist)
const WhatWeBelieveFallback = () => <div className="py-10 text-center text-gray-700">What We Believe Section</div>;
const WhatDifferentiatesFallback = () => <div className="py-10 text-center text-gray-700">What Differentiates Section</div>;
const OurClienteleFallback = () => <div className="py-10 text-center text-gray-700">Our Clientele Section</div>;
const GetInTouchUsFallback = () => <div className="py-10 text-center text-gray-700">Get In Touch Section</div>;

const motionVariants = [
  { initial: { opacity: 0, scale: 0.9, y: 30 }, animate: { opacity: 1, scale: 1, y: 0 } },
  { initial: { opacity: 0, x: -50, rotateX: 15 }, animate: { opacity: 1, x: 0, rotateX: 0 } },
  { initial: { opacity: 0, y: 100, scale: 0.8 }, animate: { opacity: 1, y: 0, scale: 1 } },
  { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 } }
];

const AboutTechMentee = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    setIsVisible(true);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Advanced motion properties with staggered animations
  const motionProperties = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, ease: "easeOut" }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden pt-14">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-br from-blue-100/30 to-purple-100/30 rounded-full blur-3xl"
          style={{ transform: `translateY(${scrollY * 0.1}px)` }}
        />
        <div
          className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-tr from-orange-100/30 to-yellow-100/30 rounded-full blur-3xl"
          style={{ transform: `translateY(${scrollY * -0.1}px)` }}
        />
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400/40 rounded-full animate-pulse" />
        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-orange-400/40 rounded-full animate-pulse delay-1000" />
        <div className="absolute top-1/2 right-1/3 w-1.5 h-1.5 bg-purple-400/40 rounded-full animate-pulse delay-500" />
      </div>

      <div className="relative lg:px-20 md:px-10 px-5 py-16 tracking-wider">
        {/* Enhanced Hero Title */}
        <div
          className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          style={{ transitionDelay: '0.2s' }}
        >
          <div className="text-center mb-16">
            <h1 className="relative inline-block">
              <span className="text-slate-100 font-bold md:text-4xl lg:text-5xl text-2xl tracking-wider lg:w-[60%] block m-auto leading-tight">
                Powering Career{' '}
                <span className="relative inline-block">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 via-orange-500 to-yellow-500 font-extrabold animate-pulse">
                    Success
                  </span>
                </span>
                {' '}with Immersive Learning Experiences
              </span>
              {/* Floating particles around title */}
              <div className="absolute -top-4 -left-4 w-3 h-3 bg-blue-400/60 rounded-full animate-bounce delay-300" />
              <div className="absolute -top-2 -right-6 w-2 h-2 bg-orange-400/60 rounded-full animate-bounce delay-700" />
            </h1>
          </div>
        </div>

        {/* Enhanced Content Card */}
        <div
          className={`transform transition-all duration-1200 ${isVisible ? 'opacity-100 translate-y-0 rotate-0' : 'opacity-0 translate-y-12 rotate-1'
            }`}
          style={{ transitionDelay: '0.6s' }}
        >
          <div className="relative bg-gradient-to-br from-blue-600 via-blue-500 to-cyan-500 text-white my-8 p-12 leading-8 rounded-3xl pb-48 text-justify flex flex-col gap-6 shadow-2xl backdrop-blur-sm border border-blue-400/20 overflow-hidden group hover:shadow-blue-500/25 transition-all duration-500">
            {/* Card background effects */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out" />
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-16 translate-x-16 blur-xl" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-cyan-300/10 rounded-full translate-y-12 -translate-x-12 blur-xl" />

            {/* Enhanced content */}
            <div
              className={`relative z-10 transform transition-all duration-800 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
                }`}
              style={{ transitionDelay: '1s' }}
            >
              <p className="text-xl leading-relaxed font-light relative">
                <span className="text-2xl text-cyan-200 float-left mr-2 mt-1 font-bold">"</span>
                Techmentee is the best training and placement agency in Atlanta, GA, USA creating immersive digital learning experiences for learners globally. We help professionals and students get trained and upskill themselves with job-ready skills they must be needing to excel in their careers.              </p>
            </div>

            <div
              className={`relative z-10 transform transition-all duration-800 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
                }`}
              style={{ transitionDelay: '1.3s' }}
            >
              <p className="text-xl leading-relaxed font-light">
                Besides offering various specializations, we also assist businesses with bespoke custom IT solutions through multiple practices and cutting-edge technologies. Our consultants are recognized for their technical capabilities and commitment to excellence, which has enabled us to establish a robust presence as the best software company in Atlanta, GA, USA, with offices essentially based in the US and India.
              </p>
            </div>

            {/* Floating elements inside card */}
            <div className="absolute top-8 right-8 w-4 h-4 border-2 border-cyan-300/40 rounded-full animate-spin" style={{ animationDuration: '8s' }} />
            <div className="absolute bottom-20 right-12 w-6 h-6 border border-white/20 rounded-lg rotate-45 animate-pulse" />
          </div>
        </div>

        {/* Enhanced Image Section */}
        <div
          className={`relative md:w-[90%] m-auto transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'
            }`}
          style={{ marginTop: '-190px', transitionDelay: '1.6s' }}
        >
          <div className="relative group">
            {/* Enhanced image container with multiple layers */}
            <div className="relative overflow-hidden rounded-3xl shadow-2xl backdrop-blur-sm border border-white/20">
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 via-transparent to-white/10 z-10" />
              <img
                src={about_us_success_image}
                alt="Success Journey Visualization"
                className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700 ease-out"
                onError={(e) => {
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='400' viewBox='0 0 800 400'%3E%3Cdefs%3E%3ClinearGradient id='grad1' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23667eea;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23764ba2;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='800' height='400' fill='url(%23grad1)' /%3E%3Ctext x='400' y='200' font-family='Arial' font-size='24' fill='white' text-anchor='middle' dominant-baseline='middle'%3ESuccess Journey Visualization%3C/text%3E%3C/svg%3E";
                }}
              />

              {/* Overlay effects */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1200 ease-out z-20" />
            </div>

            {/* Floating elements around image */}
            <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-full animate-bounce opacity-70 shadow-lg" style={{ animationDelay: '0.5s' }} />
            <div className="absolute -top-2 -right-6 w-6 h-6 bg-gradient-to-br from-orange-400 to-yellow-400 rounded-full animate-bounce opacity-70 shadow-lg" style={{ animationDelay: '1s' }} />
            <div className="absolute -bottom-4 left-1/4 w-5 h-5 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full animate-bounce opacity-70 shadow-lg" style={{ animationDelay: '1.5s' }} />
          </div>
        </div>

        {/* Enhanced section spacing and animations */}
        <div className="mt-20 space-y-16">
          <div
            className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            style={{ transitionDelay: '2s' }}
          >
            {WhatWeBelieveComponent ? <WhatWeBelieveComponent /> : <WhatWeBelieveFallback />}
          </div>

          <div
            className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            style={{ transitionDelay: '2.2s' }}
          >
            {WhatDifferentiates ? <WhatDifferentiates /> : <WhatDifferentiatesFallback />}
          </div>

          <div
            className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            style={{ transitionDelay: '2.4s' }}
          >
            {OurClientele ? <OurClientele /> : <OurClienteleFallback />}
          </div>

          <div
            className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'
              }`}
            style={{ transitionDelay: '2.6s' }}
          >
            {GetInTouchUs ? <GetInTouchUs /> : <GetInTouchUsFallback />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTechMentee;